import apiExcel from '@/api/excel'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  excelApplicationsReportingStart:
    '[excel applications-reporting] excel applications-reporting start',
  excelApplicationsReportingSuccess:
    '[excel applications-reporting] excel applications-reporting success',
  excelApplicationsReportingFailure:
    '[excel applications-reporting] excel applications-reporting failure',
}

export const actionTypes = {
  excelApplicationsReporting:
    '[excel applications-reporting] applications-reporting excel',
}

const mutations = {
  [mutationTypes.excelApplicationsReportingStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.excelApplicationsReportingSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.excelApplicationsReportingFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.excelApplicationsReporting](context, {id}) {
    context.commit(mutationTypes.excelApplicationsReportingStart)
    return new Promise((resolve) => {
      apiExcel
        .applicationsReporting(id)
        .then((response) => {
          context.commit(mutationTypes.excelApplicationsReportingSuccess)
          const file = new Blob([response.data], {
            type: response.headers['content-type'],
          })

          const link = URL.createObjectURL(file)
          resolve(link)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.excelApplicationsReportingFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
